import { Graphics } from "pixi.js";
import { TileImageConfig } from "../types/types";
import { useCallback } from "react";

export function GhostTile({
  tileImageConfig,
}: {
  tileImageConfig: TileImageConfig;
}) {
  const { width, height, cornerRadius, fill } = tileImageConfig;
  
  const drawGhostTile = useCallback(
    function drawGhostTile(g: Graphics) {
      try {
        g.clear();
        g.setFillStyle({ color: fill as number });
        g.roundRect(0, 0, width, height, cornerRadius);
        g.fill();
      } catch (error) {
        console.warn("Error drawing GhostTile:", error);
        // Fallback: draw a simple rectangle
        g.clear();
        g.setFillStyle({ color: 0x333333 });
        g.rect(0, 0, width || 180, height || 100);
        g.fill();
      }
    },
    [width, height, cornerRadius, fill]
  );

  return <pixiGraphics draw={drawGhostTile} />;
}
